import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import GamePlay from "./pages/GamePlay";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Score from "./pages/Score";
import IncorrectAnswers from "./pages/IncorrectAnswers";
import Leaderboard from "./pages/Leaderboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<Home />} />
          <Route path="play/:id" element={<GamePlay />} />
          <Route path="score" element={<Score />} />
          <Route path="incorrect_answers" element={<IncorrectAnswers />} />
          <Route path="leaderboard" element={<Leaderboard />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
